import messages from '../../const/messages';
import hasInvalidCharactersInSctiptName from './hasInvalidCharsInScriptName';

export function validateScriptName(scriptName, project, prefix = 'Script') {
    let hasScriptWithThisName = false;

    if (scriptName && hasInvalidCharactersInSctiptName(scriptName)) {
        return `${prefix} name can contain only ASCII alphanumeric characters and -.`;
    }

    if (!scriptName) {
        return `Enter ${prefix.toLowerCase()} name`;
    }

    if (!scriptName.replace(/\./g, '').length) {
        return `${prefix} name cannot contain only . characters`;
    }

    if (project && project.scripts) {
        for (var i = 0; i < project.scripts.length; i++) {
            if (project.scripts[i].name === scriptName) {
                hasScriptWithThisName = true;
                break;
            }
        }
    }

    if (hasScriptWithThisName) {
        return `${prefix} with this name already exists`;
    }

    return null;
}